import { createFileRoute } from '@tanstack/react-router';
import { MessagesPage } from '../../features/messaging';

export const Route = createFileRoute('/portal/messages/$threadId')({
  component: function MessageThreadRoute() {
    const { threadId } = Route.useParams();
    return <MessagesPage threadId={threadId} />;
  },
});
